export default __webpack_public_path__ + "static/media/colorInstagram.7458a6ba.svg";